module.exports = __webpack_public_path__ + "img/custom_bg1.2edfefc8.png";